import VoyageMeshData from "./data";
import wayPointFromJson from "../waypoint/mapper";
export default function voyageMeshFromJson(json) {
    return new VoyageMeshData(
        json.voyageId,
        json.computation,
        json.high.map((datum) => wayPointFromJson(datum)),
        json.low.map((datum) => wayPointFromJson(datum))
    )
}

